import { IConverterContext } from "@/containers/Converter/types";

export const getInitialState = (converterCtx: IConverterContext): string => {
  return converterCtx.disabled ? "betaSignUp" : "selectingFile";
};
